import type { CapwayJob } from '@/api/types'

export const CAPWAY_JOB_LABELS: Record<CapwayJob, string> = {
  capway_billing: 'Fakturering',
  capway_sync: 'Fakturasynk'
}

export const CAPWAY_JOB_DESCRIPTIONS: Record<CapwayJob, string> = {
  capway_billing: 'Skapar fakturor för inlämnade leveranser',
  capway_sync: 'Synkroniserar fakturainfo med Capway.'
}
